import gsap from 'gsap';

const animationLeave = (container) => {

    return gsap.to('.ss-main', { autoAlpha:0, duration: .5, clearProps: 'all', ease: 'none' })

}

export default animationLeave;